import * as SwitchPrimitive from '@radix-ui/react-switch';

const Switch = SwitchPrimitive.Root;

const SwitchThumb = SwitchPrimitive.Thumb;

export { Switch, SwitchThumb };
